;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();const KNOWN_THIRD_PARTY_SCRIPTS = [
    /(?:^|\/)(?:otBannerSdk|otSDKStub|OtAutoBlock)\.js(?:$|[?#])/i,
    // Locale segments carry region subtags (recaptcha__pt_br.js) and the
    // release hash is empty when Google's loader fails to resolve a version.
    /(?:^|\/)recaptcha\/releases\/[^/]*\/recaptcha__[a-z_-]+\.js(?:$|[?#])/i,
    // Tag Manager's postMessage listener assumes every message is a string.
    /(?:^|\/)gtm\.js(?:$|[?#])/i,
];

const eventFrames = event =>
    event?.exception?.values?.flatMap(
        value => value?.stacktrace?.frames || []
    ) || [];

const framePaths = frame =>
    [frame?.filename, frame?.abs_path].filter(path => typeof path === 'string');

const eventHasKnownThirdPartyScript = event =>
    eventFrames(event).some(frame =>
        framePaths(frame).some(path =>
            KNOWN_THIRD_PARTY_SCRIPTS.some(pattern => pattern.test(path))
        )
    );

/**
 * Drops third-party failures that application-key marking cannot classify.
 * Message-only noise belongs in `ignoreErrors`, not here.
 *
 * One vendor frame is enough. Do not also require the stack to be free of
 * first-party frames: `@sentry/browser`'s handler wrapper is bundled into
 * `/_next/static/`, so these events always carry a bundle frame.
 */
export const filterSentryEvent = event =>
    eventHasKnownThirdPartyScript(event) ? null : event;
